import React, { useEffect, useRef, useState } from 'react';
import SignOut from './SignOut';
import { auth, db } from "../firebase.js";
import SendMessege from './SendMessege.js';

function Line() {
    const [messeges, setMesseges] = useState([]);
    const messagesEndRef = useRef(null);
    useEffect(() => {
        db.collection("messeges")
            .orderBy("createdAt")
            .limit(50)
            .onSnapshot((snapshot) => {
                setMesseges(snapshot.docs.map((doc) => doc.data()));
            });
    }, []);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messeges]);

    return (
        <div>
            {console.log(messeges)}
            <SignOut />
            <div className='msgs'>
                {messeges.map(({ id, text, photoURL, uid }) => (
                    <div>
                        <div key={id}
                            className={`msg ${uid === auth.currentUser.uid ? "sent" : "received"
                                }`}
                        >
                            <img src={photoURL} alt="" />
                            <p>{text}</p>
                        </div>
                    </div>
                ))}
                <div ref={messagesEndRef} /> 
            </div>
            <SendMessege />
        </div>
    );
}

export default Line;